export type ImageState = {
    fileName: string | null;
    fileUpload: File | null;

    setFileName: (filename: string) => void;
    setFileUpload: (file: File) => void;

    clear: () => void;
};

export const imageStore = (
    set: (state: ImageState) => void,
    get: () => ImageState,
): ImageState => ({
    fileName: null,
    fileUpload: null,

    setFileName: (filename: string) => {
        set({
            ...get(),
            fileName: filename,
        });
    },

    setFileUpload: (file: File) => {
        set({
            ...get(),
            fileUpload: file,
        });
    },

    clear: () => {
        set({
            fileName: null,
            fileUpload: null,

            setFileName: () => {},
            setFileUpload: () => {},

            clear: () => {},
        });
    },
});
